import Swiper, { Autoplay, EffectFade } from 'swiper';

class Programs {
  constructor() {
    this.programsLinks = document.querySelectorAll('.js-programs-item-inner');
    this.bgSliders = document.querySelectorAll('.js-programs-bg-slider');

    if (!this.programsLinks.length && !this.bgSliders.length) {
      return;
    }

    this.init();
  }

  init() {
    this.programsLinks.forEach(link => {
      link.addEventListener('click', e => {
        if (e.target.classList.contains('js-media-credits-button')) {
          e.preventDefault();
        }
      });
    });

    this.bgSliders.forEach(el => {
      /* eslint-disable no-new */
      new Swiper(el, {
        modules: [Autoplay, EffectFade],
        effect: 'fade',
        fadeEffect: { crossFade: true },
        loop: true,
        autoplay: { delay: 4000, disableOnInteraction: false },
        speed: 1500,
        allowTouchMove: false,
        navigation: false,
        pagination: false,
      });
    });
  }
}

export default new Programs();



// WEBPACK FOOTER //
// ./src/scripts/modules/programs.js